import React, { lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EventsPage from './pages/EventsPage';
import SchedulePage from './pages/SchedulePage';
import NewsPage from './pages/NewsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SchoolsPage from './pages/SchoolsPage';
import LoginPage from './pages/LoginPage';
import Gala2026Page from './pages/Gala2026Page';
import Gala2025Page from './pages/Gala2025Page';
import Gala2024Page from './pages/Gala2024Page';
import EventDetailPage from './pages/EventDetailPage';
import { LanguageProvider } from './contexts/LanguageContext';

const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const DashboardPage = lazy(() => import('./pages/admin/DashboardPage'));
const PostsListPage = lazy(() => import('./pages/admin/PostsListPage'));
const PostEditorPage = lazy(() => import('./pages/admin/PostEditorPage'));
const UsersPage = lazy(() => import('./pages/admin/UsersPage'));
const EmailPage = lazy(() => import('./pages/admin/EmailPage'));
const SettingsPage = lazy(() => import('./pages/admin/SettingsPage'));
const MediaLibraryPage = lazy(() => import('./pages/admin/MediaLibraryPage'));
const SubscribersPage = lazy(() => import('./pages/admin/SubscribersPage'));

function LoadingFallback() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div className="spinner" />
    </div>
  );
}

export default function App() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <LanguageProvider>
      {!isAdmin && <Header />}
      <main>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            {/* English routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/gala" element={<Gala2026Page />} />
            <Route path="/gala/2025" element={<Gala2025Page />} />
            <Route path="/gala/2024" element={<Gala2024Page />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:slug" element={<EventDetailPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/schools" element={<SchoolsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />

            {/* Chinese routes */}
            <Route path="/zh" element={<HomePage />} />
            <Route path="/zh/gala" element={<Gala2026Page />} />
            <Route path="/zh/gala/2025" element={<Gala2025Page />} />
            <Route path="/zh/gala/2024" element={<Gala2024Page />} />
            <Route path="/zh/events" element={<EventsPage />} />
            <Route path="/zh/events/:slug" element={<EventDetailPage />} />
            <Route path="/zh/schedule" element={<SchedulePage />} />
            <Route path="/zh/news" element={<NewsPage />} />
            <Route path="/zh/schools" element={<SchoolsPage />} />
            <Route path="/zh/about" element={<AboutPage />} />
            <Route path="/zh/contact" element={<ContactPage />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="posts" element={<PostsListPage />} />
              <Route path="posts/new" element={<PostEditorPage />} />
              <Route path="posts/:id/edit" element={<PostEditorPage />} />
              <Route path="media" element={<MediaLibraryPage />} />
              <Route path="subscribers" element={<SubscribersPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="email" element={<EmailPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Routes>
        </Suspense>
      </main>
      {!isAdmin && <Footer />}
    </LanguageProvider>
  );
}
